/**
 * This is a container for all route handlers. It can be simple and
 * dumb as is (passes route params down to RouteHandler),
 * but allows for an extra layer of control over all nested routes in needed.
 */

import React from 'react';
import { Tracking as nwTracking } from '@nerdwallet/nw-client-lib';
import { RouteChildrenProps } from 'react-router';
import AppRoutes from './app-routes';

export type RouterPathParams = {
  slug: string;
};

export type ReactRouterChildrenProps = RouteChildrenProps<RouterPathParams>;

export default class Container extends React.Component<ReactRouterChildrenProps> {
  static displayName = 'RouteContainer';

  componentDidMount(): void {
    const { location } = this.props;
    // Fire logPageView on first load to get the previous path variable set up
    nwTracking.logPageView(location.pathname);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps: any): number | void {
    const { location } = this.props;
    // Log the page view when the route changes.
    if (location.pathname !== nextProps.location.pathname) {
      // TODO: Move the error handling on nw-client-lib.
      nwTracking.logPageView(nextProps.location.pathname);
    }
  }

  render(): React.ReactNode {
    return (
      <div className="route-container">
        <AppRoutes {...this.props} />
      </div>
    );
  }
}
